import { createSlice } from '@reduxjs/toolkit'
import { strapiFetch, StrapiApiError } from '../../api/strapi'

const slice = createSlice({
    name: 'career',
    initialState: {
        data: null,
        loading: false,
        loaded: false,
        error: null,
    },
    reducers: {
        setLoading: (state, action) => { state.loading = action.payload },
        setLoaded: (state, action) => { state.loaded = action.payload },
        setData: (state, action) => { state.data = action.payload },
        setError: (state, action) => { state.error = action.payload },
    },
})

export default slice.reducer

const { setLoading, setLoaded, setData, setError } = slice.actions

export const loadCareerData = (locale) => async dispatch => {
    dispatch(setLoading(true))
    dispatch(setError(null))
    try {
        const json = await strapiFetch('/api/career', {
            locale,
            params: {
                'populate[linkButton]': 'true',
            },
        })
        dispatch(setData(json.data))
        dispatch(setLoaded(true))
    } catch (e) {
        dispatch(setError(e instanceof StrapiApiError ? e.message : 'Failed to load career data'))
    } finally {
        dispatch(setLoading(false))
    }
}
